import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'
import { FormElement, InputText } from 'mailup-web-components'
import { modalSaveState } from 'Pages/TemplateEdit/recoil/state/modals'

const InputTitle = ({ onChange }) => {
  const intl = useIntl()
  const [{ title, dirty, valid }, setModalSaveState] = useRecoilState(
    modalSaveState
  )

  const handleChangeTitle = e => {
    const value = e.target.value
    setModalSaveState(prev => ({
      ...prev,
      title: value,
      dirty: true,
      valid: value.trim().length > 0
    }))
  }

  return (
    <FormElement
      labelFor='templateTitle'
      label={intl.formatMessage({
        id: 'Load.Bee.ModalLabelForTemplate'
      })}
      required
    >
      <InputText
        value={title}
        onChange={handleChangeTitle}
        variant={!valid && dirty ? 'danger' : undefined}
      />
    </FormElement>
  )
}

InputTitle.propTypes = {
  onChange: PropTypes.func
}

export default InputTitle
